export enum SessionTypeEnum {
	Upcoming = 'upcoming',
	Past = 'past',
	Payments ='payments',
	Cancelled ='cancelled'
}